export default __webpack_public_path__ + "static/media/8.fa92e30c.svg";